import { render, staticRenderFns } from "./_base-table-footer.vue?vue&type=template&id=002845af&scoped=true&"
import script from "./_base-table-footer.vue?vue&type=script&lang=js&"
export * from "./_base-table-footer.vue?vue&type=script&lang=js&"
import style0 from "./_base-table-footer.vue?vue&type=style&index=0&id=002845af&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002845af",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VPagination,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('002845af')) {
      api.createRecord('002845af', component.options)
    } else {
      api.reload('002845af', component.options)
    }
    module.hot.accept("./_base-table-footer.vue?vue&type=template&id=002845af&scoped=true&", function () {
      api.rerender('002845af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-table-footer/_base-table-footer.vue"
export default component.exports